<template lang="pug">
  theme-provider(:theme="theme")
    main.main.main__where-to-get
      .main__header
        h1.main__title {{ $t('whereToGet.title') }}
        h2.main__subtitle {{ $t('whereToGet.warning') }}
      .main__container
        .main__content
          form.form.form_where-to-get(@submit.prevent="submitForm")
            .form__row
              label.form__label label
              .form__filed.form__field_row
                RadioButton(
                  value="np"
                  :label="$t('whereToGet.regionCheckbox.np')"
                  name="delivery"
                )
                RadioButton(
                  value="sho"
                  :label="$t('whereToGet.regionCheckbox.sho')"
                  name="delivery"
                )
            h2.form__text.form__title {{ $t('service-request.requireUcraine.title') }}
              .form__text-row
                .form__text-row_1
                  h3.form__text.form__text_bold {{ $t('service-request.requireUcraine.post') }}
                  address.form__text.form__text_gray.form__address {{ $t('service-request.requireUcraine.address') }}
                .form__text-row_2
                  span.form__price.form__text.form__text_gray {{ $t('service-request.requireUcraine.price') }}
              footer.form__footer
                a.link-back(@click="$router.go(-1)") {{ $t('service-request.buttons.back') }}
                input.button.form__submit(type="submit" :value="$t('whereToGet.buttons.choseAddress')")
</template>

<script>
import { theme } from '@/thems'
import { ThemeProvider } from 'vue-styled-components'
import { RadioButton } from '@/components/RadioButton'
export default {
  name: 'Request_Where-to-get',
  data: () => ({
    theme: theme,
    delivery: 'np'
  }),
  methods: {
    submitForm () {
      this.$router.push({path: '/whereDelivery'})
    },
    handleChange (value) {
      this.delivery = value
    }
  },
  components: {
    RadioButton,
    'theme-provider': ThemeProvider
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Request_Where-to-get.vue